module.exports = __webpack_public_path__ + "img/icon-indi-96-electric.6c70f2cd.svg";